// extracted by mini-css-extract-plugin
module.exports = {"root":"Entity_root__MaGTf"};